export default {
  SET_AFFECTED_USER: 'SET_AFFECTED_USER',
  SET_SEARCH_CRITERIA_USER: 'SET_SEARCH_CRITERIA_USER',
}
